import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const FindingsApprovedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SUNRUN_FINDINGS_APPROVED),
  projectId: z.number(),
  reason: z.enum(["FINDINGS_REJECTED_MISSING_PERMIT", "FINDINGS_REJECTED_MISSING_PHOTOS", "FINDINGS_REJECTED_OTHER"]),
});

export type FindingsApprovedTaskAttempt = z.infer<typeof FindingsApprovedTaskAttemptSchema>;
